import BaseDialog from "@/components/BaseDialog";

// 工单管理-待指派 驳回
export function withdrawModal({ props, cbs, on }) {
    return new BaseDialog({
        component: ()=>import('./withdrawModal.vue'),
        options: {
            width: '600px',
            title: '温馨提示',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
        on
    })
}


// 批量指派 改派
export function batchAssignModal({ props, cbs,slots, on, title }) {
    return new BaseDialog({
        component: ()=>import('./batchAssignModal/index.vue'),
        options: {
            width: '650px',
            title: title || '批量指派',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            wrapperClosable:false,
            // showClose:false,
            withHeader:false,
        },
        props,
        cbs,
        slots,
        on
    })
}

